<template>
  <div class="rounded-[8px] border border-[#E2E2E2]">
    <div class="d-flex items-center justify-content-between flex-wrap gap-[16px] p-[16px]">
      <div class="flex items-center gap-[8px] flex-wrap">
        <button
          :class="{
            'font-normal text-[14px] mb-0 px-[12px] py-[4px] rounded-full transition-all duration-300': true,
            'bg-primary text-white ': activeTab === 'cot',
            'bg-white text-[#333333] hover:!bg-[#f02b07] hover:text-white': activeTab !== 'cot',
          }"
          @click="changeTab('cot')"
        >
          Cut off time
        </button>
        <button
          :class="{
            'font-normal text-[14px] mb-0 px-[12px] py-[4px] rounded-full transition-all duration-300': true,
            'bg-primary text-white ': activeTab === 'libur',
            'bg-white text-[#333333] hover:!bg-[#f02b07] hover:text-white': activeTab !== 'libur',
          }"
          @click="changeTab('libur')"
        >
          Libur
        </button>
      </div>
      <div class="flex items-center gap-[8px]">
        <b-button
          type="submit"
          :variant="onEditMode ? 'primary' : 'secondary'"
          size="sm"
          :disabled="!onEditMode"
          :class="{'flex items-center justify-center gap-[4px] bg-[#F8F8F8] border border-[#E2E2E2] text-[#333333] font-normal text-[14px] mb-0 px-[12px] py-[4px] rounded-[8px] transition-all duration-300': true,
          }"
          @click="handleAddOperationalTime"
        >
          <span class="k-add text-[14px]" />Tambah
        </b-button>
      </div>
    </div>

    <COTTable
      v-if="activeTab === 'cot'"
      ref="cotTable"
      :warehouse-id="warehouseId"
      :on-edit-mode="onEditMode"
      @request-delete="handleRequestDeleteCutOffTime"
      @request-edit="handleRequestEditCutOffTime"
    />

    <HariLiburTable
      v-if="activeTab === 'libur'"
      ref="liburTable"
      :warehouse-id="warehouseId"
      :on-edit-mode="onEditMode"
      @request-delete="handleRequestDeleteHariLibur"
      @request-edit="handleRequestEditHariLibur"
    />

    <ModalHariLiburForm
      ref="modalHariLiburForm"
      @success="handleSuccessModal"
    />

    <ModalCutOffTimeForm
      ref="modalCoTForm"
      @success="handleSuccessModal"
    />

    <ModalGeneralAction ref="mgac_kompack" />
  </div>
</template>

<script>
import { toastError, toastSuccess } from '@/libs/toastification'
import { fieldsCutOfTime } from '../config'
import ModalHariLiburForm from './ModalHariLiburForm.vue'
import COTTable from './COTTable.vue'
import HariLiburTable from './HariLiburTable.vue'
import ModalGeneralAction from './ModalGeneralAction.vue'
import ModalCutOffTimeForm from './ModalCutOffTimeForm.vue'

/**
 * CIGOperationalTime
 * @description CIGOperationalTime is a component that displays, edit and delete the operational time of the warehouse
 * @param {Boolean} onEditMode - The on edit mode
 * @param {Number} warehouseId - The warehouse id
 * @returns {Object} CIGOperationalTime
 */
export default {
  name: 'CIGOperationalTime',
  components: {
    ModalHariLiburForm,
    COTTable,
    HariLiburTable,
    ModalGeneralAction,
    ModalCutOffTimeForm,
  },
  props: {
    onEditMode: {
      type: Boolean,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'cot',
      items: [],
      fields: fieldsCutOfTime,
    }
  },
  methods: {
    /**
     * Change the tab
     * @param {String} tab - The tab, can be 'cot' or 'libur'
     */
    changeTab(tab) {
      if (this.activeTab === tab) {
        return
      }
      this.activeTab = tab
    },
    /**
     * Show the modal hari libur
     */
    showModalHariLibur() {
      this.$refs.modalHariLiburForm.show({
        mode: 'add',
        index: null,
        initialData: null,
      })
    },
    /**
     * Show the modal cut off time
     */
    handleAddOperationalTime() {
      if (this.activeTab === 'cot') {
        this.$refs.modalCoTForm.show({
          mode: 'add',
          initialData: null,
        })
      }
      if (this.activeTab === 'libur') {
        this.$refs.modalHariLiburForm.show({
          mode: 'add',
          initialData: null,
        })
      }
    },
    /**
     * Handle condition when the modal is success
     */
    handleSuccessModal() {
      if (this.activeTab === 'cot') {
        this.$refs.cotTable.refetchData()
      }
      if (this.activeTab === 'libur') {
        this.$refs.liburTable.refetchData()
      }
    },
    /**
     * Handle the request edit hari libur
     * @param {Object} item - The item
     */
    handleRequestEditHariLibur(item) {
      this.$refs.modalHariLiburForm.show({
        mode: 'edit',
        initialData: item,
      })
    },
    /**
     * Handle the request delete hari libur
     * @param {Object} item - The item
     */
    handleRequestDeleteHariLibur(item) {
      this.$refs.mgac_kompack.show({
        title: 'Konfirmasi Hapus Hari Libur',
        message: 'Anda yakin ingin menghapus data ini?',
        confirmText: 'Hapus',
        onConfirm: ({
          hide,
          setIsLoading,
        }) => {
          setIsLoading(true)
          this.mutateDeleteOperationalTime(item).then(() => {
            hide()
            setIsLoading(false)
          }).catch(() => {
            setIsLoading(false)
          })
        },
      })
    },
    /**
     * Handle the request edit cut off time
     * @param {Object} item - The item
     */
    handleRequestEditCutOffTime(item) {
      this.$refs.modalCoTForm.show({
        mode: 'edit',
        initialData: item,
      })
    },
    /**
     * Handle the request delete cut off time
     * @param {Object} item - The item
     */
    handleRequestDeleteCutOffTime(item) {
      this.$refs.mgac_kompack.show({
        title: 'Konfirmasi Hapus Cut Off Time',
        message: 'Anda yakin ingin menghapus data ini?',
        confirmText: 'Hapus',
        onConfirm: ({
          hide,
          setIsLoading,
        }) => {
          setIsLoading(true)
          this.mutateDeleteOperationalTime(item).then(() => {
            hide()
            setIsLoading(false)
          }).catch(() => {
            setIsLoading(false)
          })
        },
      })
    },
    /**
     * Mutate the delete operational time
     * @param {Object} item - The item
     */
    async mutateDeleteOperationalTime(item) {
      try {
        await this.$http_new.delete(`/komship/api/v1/warehouse-operational-times/${item.id}`)
        if (this.activeTab === 'cot') {
          this.$refs.cotTable.refetchData()
        }
        if (this.activeTab === 'libur') {
          this.$refs.liburTable.refetchData()
        }
        toastSuccess('Data berhasil dihapus')
      } catch (error) {
        toastError('Gagal menghapus data, silahkan coba lagi')
        throw error
      }
    },
  },
}
</script>
